import React, { Fragment, useEffect, useState } from 'react'
import axios from 'axios'
import { useCookies } from 'react-cookie';

import { shuffle } from '../Utils/general'

import { RxEyeClosed, RxEyeOpen } from 'react-icons/rx'
import { AiOutlineNumber } from 'react-icons/ai'
import { RiNumber0, RiNumber1, RiNumber2, RiNumber3, RiNumber4, RiNumber5, RiNumber6, RiNumber7, RiNumber8, RiNumber9 } from 'react-icons/ri'
import { BiSend } from 'react-icons/bi'
import { MdOutlineKeyboardBackspace, MdClear } from 'react-icons/md'
import { GiKeyLock, GiCancel } from 'react-icons/gi'
import { GrStatusGood } from 'react-icons/gr'

import '../Styles/Register.css'
import '../Styles/Form.css'

import { Link } from 'react-router-dom'
import { useStateValue } from '../Utils/StateProvider'
import Footer from '../Components/Footer'

function Reset() {
    const [{ url }, payload] = useStateValue()
    const [ct, setCT] = useState('')
    const [resetData, setResetData] = useState({})
    const [resetter, setResetter] = useState({})
    const [activeStage, setActiveStage] = useState(1)
    const [viewPass, setViewPass] = useState(false)
    const [viewCPass, setViewCPass] = useState(false)
    const [hasReset, setHasReset] = useState(false)
    const [input, setInput] = useState('')
    const [error, setError] = useState(null)
    const [cookies, setCookie, removeCookie] = useCookies(['bearerToken']);
    

    const form_row_count = 3

    let buttons = [
        <RiNumber0 data-number={0} onClick={e => setInput(`${input}0`)} />,
        <RiNumber1 data-number={1} onClick={e => setInput(`${input}1`)} />,
        <RiNumber2 data-number={2} onClick={e => setInput(`${input}2`)} />,
        <RiNumber3 data-number={3} onClick={e => setInput(`${input}3`)} />,
        <RiNumber4 data-number={4} onClick={e => setInput(`${input}4`)} />,
        <RiNumber5 data-number={5} onClick={e => setInput(`${input}5`)} />,
        <RiNumber6 data-number={6} onClick={e => setInput(`${input}6`)} />,
        <RiNumber7 data-number={7} onClick={e => setInput(`${input}7`)} />,
        <RiNumber8 data-number={8} onClick={e => setInput(`${input}8`)} />,
        <RiNumber9 data-number={9} onClick={e => setInput(`${input}9`)} />

    ]

    buttons = shuffle(buttons)

    const clearForm = () => {
        setResetData({})
        setActiveStage(1)
    }

    const goForward = async () => {
        setError(null)
        switch (activeStage) {
            case 1:
                if (!resetData.account) return setError('Account number required')
                payload({
                    type: 'TOGGLE_PROCESSING',
                    state: true
                })
                try{
                    const getUD = await axios.get(`${url}/api/u/validate?account=${resetData.account}`, {
                        headers: { Authorization: `Bearer ${cookies.bearerToken}` }
                    })
                    setResetter(getUD.data.data)
                    const getBT = await axios.get(`${url}/api/m/otp?uid=${getUD.data.data.uid}`, {
                        headers: {
                            Authorization: `Bearer ${cookies.bearerToken}`
                        }
                    })
                    setCT(getBT.data.data)
                    setActiveStage(2)
                }catch (err) {
                    return setError(err.response.data.message)
                }finally {
                    payload({
                        type: 'TOGGLE_PROCESSING',
                        state: false
                    })
                }
                break;
            case 2:
                if (!input || input === '' || input.length !== 8) return setError('Required OTP has not been provided or is invalid')

                payload({
                    type: 'TOGGLE_PROCESSING',
                    state: true
                })
                try {
                    await axios.post(`${url}/api/m/otp`, {
                        token: `Bearer ${ct}`,
                        otp: input
                    }, {
                        headers: {
                            Authorization: `Bearer ${cookies.bearerToken}`
                        }
                    })
                    setActiveStage(3)
                } catch(err) {
                    return setError(err.response.data.message)
                }finally {
                    payload({
                        type: 'TOGGLE_PROCESSING',
                        state: false
                    })
                }
                break;
            case 3:
                if (
                    !resetData.password ||
                    !resetData.cpassword
                ) return setError('fill all required fields')

                if (resetData.password.length < 6) return setError('Password too short')

                if (resetData.password !== resetData.cpassword) return setError('Password mismatch')

                payload({
                    type: 'TOGGLE_PROCESSING',
                    state: true
                })
                try {
                    await axios.patch(`${url}/api/u`, {
                        validators: {
                            uid: resetter.uid
                        },
                        setters: {
                            password: resetData.password
                        }
                    }, {
                        headers: {
                            Authorization: `Bearer ${cookies.bearerToken}`
                        }
                    })

                    setActiveStage(4)
                    setHasReset(true)
                    removeCookie('bearerToken')
                } catch(err) {
                    setError(err.response.data.message)
                }finally {
                    payload({
                        type: 'TOGGLE_PROCESSING',
                        state: false
                    })
                }
                break;
        }
    }

    const setBearer = async (source) => {
        try {
            const getToken = await axios.get(`${url}/api/m?local=true`, { cancelToken: source.token })
            setCookie('bearerToken', getToken.data.token, { path: '/', expires: new Date(new Date().getTime() + (1000 * 60 * 60) ) })
        }catch (err) {
            console.error(err.message)
        }
    }

    
    useEffect(() => {
        const source = axios.CancelToken.source()
        if (!cookies.bearerToken || [undefined, 'undefined', null, 'null'].includes(cookies.bearerToken)) setBearer(source)
        return () => {
            source.cancel()
        }
    }, [])

    return (
        <Fragment>
            <main className='reset'>
                <div className="container">
                    <div className="row top-banner">
                        <div className="desc">
                            <h1>Reset Password</h1>
                        </div>
                    </div>
                    <div className="row form-container">
                        <form className='default'>
                        {
                            error && (
                                <div className="error-box">{error}</div>
                            )
                        }
                        {
                            activeStage === 1 && (
                                <div className="form-pt-one personal-data">
                                    <h1>Identification</h1>
                                    <div className="form-row input-row">
                                        <input type="text" name='account' id='account' value={resetData.account || ''} onChange={e => setResetData({ ...resetData, account: e.target.value })} required />
                                        <label htmlFor="account">Account Number</label>
                                        <AiOutlineNumber />
                                    </div>
                                </div>
                            )
                        }
                        {
                            activeStage === 2 && (
                                <div className="form-pt-two personal-data">
                                    <h1>PassCode</h1>
                                    <p><span style={{fontStyle: 'italic', fontWeight: 700, color: '#fff', fontSize: '12px', marginRight: 10, backgroundColor: 'red', padding: 5}}>NB</span>A One Time Password (OTP) code has been sent to the email address linked to this account. Please confirm below to proceed.</p>
                                    <div className="form-row input-row not-required">
                                        <input type="text" name='otp' id='otp' defaultValue={input} readOnly />
                                        <label htmlFor="otp">One Time Pass Code</label>
                                        <GiKeyLock />
                                    </div>
                                    <div className="form-row digit-btns">
                                        <div className="buttons">
                                            {
                                                buttons.map((button, index) => <div key={index} className='button'>{button}</div>)
                                            }
                                        </div>
                                        <div className="controls">
                                            <div className="control"><MdOutlineKeyboardBackspace onClick={() => setInput(input.slice(0, input.length - 1))} /></div>
                                            <div className="control"><MdClear onClick={() => setInput('')} /></div>
                                            <div className="control"><BiSend onClick={goForward} /></div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {
                            activeStage === 3 && (
                                <div className="form-pt-three personal-data">
                                    <h1>Change Passphrase</h1>
                                    <div className="form-row input-row password-row">
                                        <input type={viewPass ? "text" : "password"} name='password' id='password' onChange={e => setResetData({ ...resetData, password: e.target.value })} required />
                                        <label htmlFor="password">New Passphrase</label>
                                        {
                                            viewPass ? (
                                                <RxEyeOpen onClick={() => setViewPass(false)} />
                                            ) : (
                                                <RxEyeClosed onClick={() => setViewPass(true)} />
                                            )
                                        }
                                    </div>
                                    <div className="form-row input-row password-row">
                                        <input type={viewCPass ? "text" : "password"} name='cpassword' id='cpassword' onChange={e => setResetData({ ...resetData, cpassword: e.target.value })} required />
                                        <label htmlFor="cpassword">Confirm Passphrase</label>
                                        {
                                            viewCPass ? (
                                                <RxEyeOpen onClick={() => setViewCPass(false)} />
                                            ) : (
                                                <RxEyeClosed onClick={() => setViewCPass(true)} />
                                            )
                                        }
                                    </div>
                                </div>
                            ) 
                        }
                        {
                            activeStage === 4 && (
                                <div className='form-pt-three'>
                                {
                                    hasReset ? (
                                        <div className="response-screen success">
                                            <GrStatusGood />
                                            <p>
                                                You have successfully changed your account password.
                                                Log onto your account's online dashboard through the <Link to='/'>account authentication panel</Link>
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="response-screen error">
                                            <GiCancel />
                                            <p>
                                                Could not complete this action. Reason(s):: {error}.
                                                Please try again in 30 minutes. <Link to='/'>back to login</Link>
                                            </p>
                                        </div>
                                    )
                                }
                                </div>
                            )
                        }
                            <div className="btn-row split-row">
                                <div className="left-column">
                                    {
                                        activeStage > 1 && activeStage < form_row_count && (
                                            <button type='button' onClick={() => setActiveStage(activeStage - 1)}>Back</button>
                                        )
                                    }
                                </div>
                                <div className="right-column">
                                    {
                                        activeStage < form_row_count && (
                                            <button type='button' onClick={goForward}>{activeStage === 1 ? 'Submit' : activeStage === 2 ? 'Verify' : 'Reset Password'}</button>
                                        )
                                    }
                                </div>
                            </div>
                            {
                                activeStage === form_row_count && (
                                    <div className="btn-row split-row">
                                        <button type='button' onClick={goForward}>Reset</button>
                                        <strong onClick={clearForm}>cancel</strong>
                                    </div>
                                )
                            }
                            <div className="summary-row">
                                <Link to='/'>Return to login page</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
            <Footer />
        </Fragment>
    )
}

export default Reset
